import React, { FC, ReactNode } from 'react'
import './icon.scss'

export const PropertyPriceIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/9819097d655eeaefc3694716d297a58b_PropertyPrice.png, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/8591ec0ec104488cf09b7f27a77db7c6_PropertyPrice_2x.png, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/95676e43f25ffa0c91d6de28c99be49c_PropertyPrice_3x.png'
        }
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/9819097d655eeaefc3694716d297a58b_PropertyPrice.png'
        }
        width={128}
        height={128}
        alt={''}
      />
    </div>
  )
}
